<template>
  <vs-prompt
    :active.sync="activeProp"
    :buttons-hidden="true"
    :title="$t('confirmAction')"
    button-accept="false"
    button-cancel="filled"
    :cancel-text="$t('refuse')"
    color="warning"
    class="confirm-popup"
  >
    <div class="con-exemple-prompt">
      <div class="flex justify-end mt-8">
        <vs-button @click="confirm" color="warning">{{
          $t("confirm")
        }}</vs-button>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
export default {
  name: "ConfirmActionPopup",
  props: {
    active: { default: false, type: Boolean },
  },
  computed: {
    activeProp: {
      get() {
        return this.active;
      },
      set(value) {
        this.$emit("update:active", value);
        return this.active;
      },
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm", true);
      this.activeProp = false;
    },
    close() {
      this.activeProp = false;
    },
  },
};
</script>

<style lang="scss">
.confirm-popup {
  .vs-dialog {
    max-width: 270px;
  }
}
</style>